import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-mws-settlement-reports-identity',
  templateUrl: './help-mws-settlement-reports-identity.component.html'
})
export class HelpMwsSettlementReportsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
